import { notification } from 'antd';
import React, { useCallback, useState } from 'react';
import { FileDrop } from 'react-file-drop';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect, useDispatch } from 'react-redux';
import { editTaskAction, uploadTaskUrlAction } from '../../../../../redux/tasks/actions';
import { signedUploadUrl } from '../../../../../actions';
import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import { getOpenedTaskFiles, getOpenedTaskTitle } from '../../../../../redux/tasks/taskEntities/selectors';



const MAX_BYTES = 1 * 1024 ** 3;

const TaskDetailsFileDropArea = ({ isModal, taskFiles, taskId, taskTitle }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [isDragNdropVisible, setIsDragNdropVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const uploadFiles = useCallback(async (files) => {
    const fileList = [];
    for (const file of files) {
      setIsLoading(true);
      const uploadTaskResponse = await dispatch(
        uploadTaskUrlAction(
          {
            fileName: file.name,
            taskId,
            type: file?.type,
            fileSize: file?.size,
          },
          undefined,
          intl,
        ),
      );
      const fileId = uploadTaskResponse?.fileId;
      const signedUrl = uploadTaskResponse?.signedUrl;
      if (signedUrl) {
        fileList.push(fileId);
        await dispatch(signedUploadUrl(signedUrl, file));
      }
    }

    let allFiles = fileList;

    if (taskFiles) {
      allFiles = fileList.concat(taskFiles || []);
    }

    dispatch(editTaskAction({
      _id: taskId,
      taskTitle,
      files: allFiles,
      attachments: [],
    }, () => {
      setIsLoading(false);
    }, () => {
      setIsLoading(false);
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskFiles, taskId, taskTitle]);

  const onFileDrop = useCallback(async (files, e) => {
    setIsLoading(true);
    setIsDragNdropVisible(false);
    document
      .querySelector('.onResize-ticket-drawer')
      ?.classList?.remove('disable-pointer-events-div');

    try {
      const filesArray = Array.from(files);
      const validFiles = filesArray.filter((file) => {
        if (file.size > MAX_BYTES) {
          notification.error({
            message: `"${file.name}" exceeds 1GB and was skipped.`,
            placement: 'bottomRight',
          });
          return false;
        }
        return true;
      });

      if (validFiles.length === 0) {
        setIsLoading(false);
        return;
      }

      await uploadFiles(validFiles);
    } catch (error) {
      console.error(error);
      notification.error({
        message: 'Upload failed.',
        placement: 'bottomRight',
      });
    } finally {
      setIsLoading(false);
    }
  }, [uploadFiles]);

  const handleDragLeave = useCallback(() => setIsDragNdropVisible(false), []);

  const handleFrameDragEnter = useCallback(() => {
    setIsDragNdropVisible(true);
    document
      .querySelector('.onResize-ticket-drawer')
      ?.classList?.add('disable-pointer-events-div');
  }, []);

  const handleFrameDragLeave = useCallback(() => {
    setIsDragNdropVisible(false);
    document
      .querySelector('.onResize-ticket-drawer')
      ?.classList?.remove('disable-pointer-events-div');
  }, []);

  const handleFrameDrop = useCallback(() => {
    setIsDragNdropVisible(false);
    document
      .querySelector('.onResize-ticket-drawer')
      ?.classList?.remove('disable-pointer-events-div');
  }, []);

  return (
    <div
      style={{
        width: '100%',
        color: 'black',
        borderRadius: '5px',
        padding: '5px 20px',
        height: isModal ? '100%' : '45vh',
      }}
      className={`fileDropDiv ${isDragNdropVisible ? '' : 'd-none'}`}
    >
      <FileDrop
        onDragLeave={handleDragLeave}
        frame={document}
        onDrop={onFileDrop}
        onFrameDragEnter={handleFrameDragEnter}
        onFrameDragLeave={handleFrameDragLeave}
        onFrameDrop={handleFrameDrop}
      >
        <FormattedMessage id="ADD_TO_TASK" defaultMessage="Add to task" />
      </FileDrop>
    </div>
  );
}

const mapStateToProps = (state) => ({
  taskFiles: getOpenedTaskFiles(state),
  taskId: getOpenedTaskId(state),
  taskTitle: getOpenedTaskTitle(state),
});

export default connect(mapStateToProps)(TaskDetailsFileDropArea);
